import React, { createContext, useContext, useState } from "react";
import ApplyDrawer from "./ApplyDrawer";

const ApplyContext = createContext(null);

export function ApplyProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <ApplyContext.Provider value={{ open: () => setOpen(true), close: () => setOpen(false) }}>
      {children}
      <ApplyDrawer open={open} onClose={() => setOpen(false)} />
    </ApplyContext.Provider>
  );
}

export function useApply() {
  const ctx = useContext(ApplyContext);
  if (!ctx) return { open: () => {}, close: () => {} };
  return ctx;
}
